import sections from "./sections";

// One search page per actual lesson. Several curriculum entries reuse the same
// module; those aliases are deliberately represented by a single canonical page.
const topicSpecs = [
  // Liczby i działania
  ["1_12_1", "system-rzymski", "zapisywać i odczytywać liczby w systemie rzymskim"],
  ["1_7_1", "dodawanie-i-odejmowanie-liczb-naturalnych", "dodawać i odejmować liczby naturalne, także w zadaniach tekstowych"],
  ["1_7_2", "mnozenie-liczb-naturalnych", "mnożyć liczby naturalne i korzystać z własności mnożenia"],
  ["1_7_3", "dzielenie-liczb-naturalnych", "dzielić liczby naturalne oraz rozpoznawać dzielenie z resztą"],
  ["1_7_4", "kolejnosc-wykonywania-dzialan", "ustalać kolejność działań w wyrażeniach z nawiasami"],
  ["1_9_1", "os-liczbowa", "zaznaczać i odczytywać liczby na osi liczbowej"],
  ["1_9_2", "dodawanie-i-odejmowanie-liczb-calkowitych", "dodawać i odejmować liczby dodatnie oraz ujemne"],
  ["1_9_3", "mnozenie-liczb-calkowitych", "mnożyć liczby całkowite i ustalać znak iloczynu"],
  ["1_9_4", "dzielenie-liczb-calkowitych", "dzielić liczby całkowite i ustalać znak ilorazu"],
  ["1_2_2", "zmiany-procentowe", "obliczać cenę lub wartość po podwyżce i obniżce procentowej"],
  ["1_2_3", "porownania-procentowe", "porównywać wielkości procentowo i odczytywać procent różnicy"],
  ["1_2_4", "procent-skladany", "obliczać kolejne zmiany procentowe za pomocą procentu składanego"],
  ["1_4_2", "potegi-o-wykladniku-calkowitym", "obliczać potęgi o wykładniku ujemnym i stosować prawa działań na potęgach"],
  ["1_1_5", "dzialania-na-pierwiastkach", "upraszczać pierwiastki oraz wykonywać działania na nich"],
  ["1_4_3", "potegi-o-wykladniku-wymiernym", "zamieniać potęgi o wykładniku wymiernym na pierwiastki i odwrotnie"],
  ["1_5_1", "definicja-logarytmu", "odczytywać logarytm jako wykładnik potęgi"],

  // Algebra
  ["2_7_1", "pojecie-wielomianu", "rozpoznawać wielomiany, ich stopień i współczynniki"],
  ["2_2_5", "rownania-wielomianowe", "rozwiązywać równania wielomianowe przez rozkład na czynniki"],
  ["2_2_6", "rownania-z-wartoscia-bezwzgledna-rozszerzenie", "rozwiązywać trudniejsze równania z wartością bezwzględną"],
  ["2_3_4", "nierownosci-z-wartoscia-bezwzgledna-rozszerzenie", "rozwiązywać trudniejsze nierówności z wartością bezwzględną"],
  ["2_4_2", "uklady-rownan-zadania-tekstowe", "układać układy równań do zadań tekstowych i interpretować wynik"],

  // Funkcje
  ["3_1_1", "pojecie-funkcji", "rozpoznawać funkcję oraz odczytywać jej argumenty i wartości"],
  ["3_1_3", "dziedzina-i-zbior-wartosci-funkcji", "odczytywać dziedzinę i zbiór wartości funkcji z wykresu"],
  ["3_1_4", "miejsca-zerowe-i-monotonicznosc-funkcji", "odczytywać miejsca zerowe i przedziały monotoniczności funkcji"],
  ["3_8_4", "wartosc-bezwzgledna-wykresu-funkcji", "rysować wykresy funkcji z wartością bezwzględną"],
  ["3_8_5", "skalowanie-wykresu-funkcji", "rozciągać i ściskać wykresy funkcji"],
  ["3_2_2", "wykres-funkcji-liniowej", "rysować wykres funkcji liniowej i odczytywać jego własności"],
  ["3_2_3", "funkcja-liniowa-zadania-tekstowe", "opisywać zadania tekstowe za pomocą funkcji liniowej"],
  ["3_3_2", "postac-kanoniczna-funkcji-kwadratowej", "wyznaczać wierzchołek paraboli z postaci kanonicznej"],
  ["3_3_3", "postac-iloczynowa-funkcji-kwadratowej", "odczytywać miejsca zerowe z postaci iloczynowej funkcji kwadratowej"],
  ["3_3_6", "optymalizacja-funkcja-kwadratowa", "wyznaczać największą lub najmniejszą wartość funkcji kwadratowej"],
  ["3_7_3", "ekstrema-funkcji", "znajdować ekstrema funkcji na podstawie pochodnej"],
  ["3_7_4", "zadania-optymalizacyjne-pochodna", "rozwiązywać zadania optymalizacyjne z pochodną"],

  // Ciągi
  ["4_1_1", "definicja-ciagu", "odczytywać wyrazy ciągu i stosować wzór ogólny"],
  ["4_1_2", "monotonicznosc-ciagow", "sprawdzać, czy ciąg jest rosnący, malejący lub stały"],
  ["4_1_3", "ciagi-rekurencyjne", "obliczać kolejne wyrazy ciągu z zależności rekurencyjnej"],
  ["4_2_2", "suma-ciagu-arytmetycznego", "obliczać sumę kolejnych wyrazów ciągu arytmetycznego"],
  ["4_2_3", "ciag-arytmetyczny-zadania-tekstowe", "stosować ciąg arytmetyczny w zadaniach tekstowych"],
  ["4_3_2", "suma-ciagu-geometrycznego", "obliczać sumę kolejnych wyrazów ciągu geometrycznego"],
  ["4_3_4", "ciag-geometryczny-zadania-tekstowe", "stosować ciąg geometryczny w zadaniach tekstowych"],

  // Trygonometria
  ["5_1_2", "wartosci-trygonometryczne-katow-ostrych", "odczytywać wartości sinusa, cosinusa i tangensa kątów ostrych"],
  ["5_1_3", "zastosowania-trygonometrii", "wykorzystywać trygonometrię do obliczania długości i kątów"],
  ["5_1_5", "rozwiazywanie-trojkata-prostokatnego", "wyznaczać brakujące boki i kąty trójkąta prostokątnego"],
  ["5_1_4", "tozsamosci-trygonometryczne-w-trojkacie-prostokatnym", "stosować podstawowe tożsamości trygonometryczne w trójkącie prostokątnym"],
  ["5_2_1", "funkcje-trygonometryczne-w-ukladzie-wspolrzednych", "wyznaczać funkcje trygonometryczne kąta w układzie współrzędnych"],
  ["5_2_2", "wzory-redukcyjne", "stosować wzory redukcyjne do obliczania wartości funkcji trygonometrycznych"],
  ["5_2_3", "tozsamosci-trygonometryczne", "przekształcać wyrażenia z użyciem tożsamości trygonometrycznych"],
  ["5_3_1", "rownania-trygonometryczne-proste", "rozwiązywać proste równania trygonometryczne na podstawie wykresów"],
  ["5_3_2", "rownania-trygonometryczne-ze-wzorami", "rozwiązywać równania trygonometryczne za pomocą wzorów"],

  // Planimetria
  ["6_1_1", "wlasnosci-trojkatow", "rozpoznawać własności trójkątów i wyznaczać brakujące wielkości"],
  ["6_1_3", "promienie-w-trojkatach", "obliczać promienie okręgów wpisanych i opisanych na trójkącie"],
  ["6_1_5", "trojkat-rownoboczny", "obliczać wysokość i pole trójkąta równobocznego"],
  ["6_1_7", "twierdzenie-talesa-i-podobienstwo-trojkatow", "stosować twierdzenie Talesa i podobieństwo trójkątów"],
  ["6_5_4", "zamiana-jednostek", "zamieniać jednostki długości, pola i objętości"],
  ["6_5_1", "skala-mapy-i-rysunku", "obliczać skalę oraz rzeczywiste i rysunkowe odległości"],
  ["6_5_2", "podobienstwo-figur", "rozpoznawać figury podobne i obliczać skalę podobieństwa"],
  ["6_5_3", "stosunek-pol-i-objetosci-figur-podobnych", "wyznaczać stosunek pól i objętości figur podobnych"],
  ["6_6_1", "zaleznosci-miedzy-katami", "obliczać kąty w układach prostych przecinających się i równoległych"],
  ["6_6_2", "katy-w-trojkatach", "wyznaczać miary kątów wewnętrznych i zewnętrznych trójkąta"],
  ["6_6_3", "katy-w-czworokatach", "wyznaczać brakujące kąty w czworokątach"],

  // Geometria analityczna
  ["7_1_5", "wektory-na-plaszczyznie", "wyznaczać współrzędne wektorów i wykonywać działania na wektorach"],
  ["7_1_4", "symetrie-w-ukladzie-wspolrzednych", "wyznaczać obrazy punktów w symetrii osiowej i środkowej"],
  ["7_2_2", "postac-ogolna-prostej", "zapisywać i przekształcać równanie prostej w postaci ogólnej"],
  ["7_2_3", "wzajemne-polozenie-prostych", "rozpoznawać proste równoległe, prostopadłe i przecinające się"],
  ["7_3_2", "postac-ogolna-rownania-okregu", "przekształcać równanie okręgu między postacią ogólną i kanoniczną"],
  ["7_3_3", "polozenie-okregu", "badać wzajemne położenie okręgu, punktu i prostej"],

  // Stereometria
  ["8_1_1", "wlasnosci-graniastoslupow", "rozpoznawać krawędzie, ściany i przekątne graniastosłupów"],
  ["8_1_2", "pole-graniastoslupa", "obliczać pole powierzchni graniastosłupa"],
  ["8_1_3", "objetosc-graniastoslupa", "obliczać objętość graniastosłupa"],
  ["8_2_1", "wlasnosci-ostroslupow", "rozpoznawać elementy i własności ostrosłupów"],
  ["8_2_2", "pole-ostroslupa", "obliczać pole powierzchni ostrosłupa"],
  ["8_2_3", "objetosc-ostroslupa", "obliczać objętość ostrosłupa"],
  ["8_3_1", "walec-pole-i-objetosc", "obliczać pole i objętość walca"],
  ["8_3_2", "stozek-pole-i-objetosc", "obliczać pole i objętość stożka"],
  ["8_3_3", "kula-pole-i-objetosc", "obliczać pole powierzchni i objętość kuli"],

  // Prawdopodobieństwo, statystyka i dowody
  ["9_2_2", "zastosowania-kombinatoryki", "zliczać możliwości w zadaniach z kombinatoryki"],
  ["9_2_3", "zdarzenia-losowe-i-ich-wlasnosci", "opisywać zdarzenia losowe i korzystać z ich własności"],
  ["9_3_2", "miary-polozenia-i-zmiennosci", "obliczać miary położenia i zmienności danych"],
];

const curriculum = new Map();
for (const section of sections) {
  for (const group of section.topics || []) {
    for (const subtopic of group.subtopics || []) {
      curriculum.set(String(subtopic.id), { title: subtopic.name, group: group.name });
    }
  }
}

const titleOverrides = {
  "2_4_2": "Układy równań – zadania tekstowe",
  "3_2_3": "Funkcja liniowa – zadania tekstowe",
  "3_1_3": "Dziedzina i zbiór wartości funkcji",
  "3_3_2": "Postać kanoniczna funkcji kwadratowej",
  "3_3_3": "Postać iloczynowa funkcji kwadratowej",
  "3_3_6": "Optymalizacja z funkcją kwadratową",
  "3_7_4": "Zadania optymalizacyjne z pochodną",
  "4_2_3": "Ciąg arytmetyczny – zadania tekstowe",
  "4_3_4": "Ciąg geometryczny – zadania tekstowe",
  "5_3_1": "Równania trygonometryczne – proste równania",
  "5_3_2": "Równania trygonometryczne ze wzorami",
  "7_1_4": "Symetrie w układzie współrzędnych",
  "7_1_5": "Wektory na płaszczyźnie",
  "7_2_2": "Postać ogólna prostej",
  "7_2_3": "Wzajemne położenie prostych",
  "7_3_2": "Postać ogólna równania okręgu",
  "7_3_3": "Wzajemne położenie okręgu, punktu i prostej",
  "8_3_1": "Walec – pole i objętość",
  "8_3_2": "Stożek – pole i objętość",
  "8_3_3": "Kula – pole i objętość",
  "9_3_2": "Miary położenia i zmienności danych",
  "10_2_1": "Dowody geometryczne dotyczące figur",
  "10_2_2": "Dowody geometryczne dotyczące kątów",
};

const curated = topicSpecs.map(([lessonId, slug, focus]) => {
  const lesson = curriculum.get(lessonId);
  if (!lesson) throw new Error(`Brak tematu ${lessonId} w spisie lekcji`);
  const title = titleOverrides[lessonId] || lesson.title;
  return {
    lessonId,
    slug,
    title,
    focus,
    group: lesson.group,
  };
});

export const expandedSeoTopicRegistry = curated.map((entry) => {
  const relatedSlugs = curated
    .filter((candidate) => candidate.group === entry.group && candidate.slug !== entry.slug)
    .slice(0, 3)
    .map((candidate) => candidate.slug);

  return {
    lessonId: entry.lessonId,
    slug: entry.slug,
    title: entry.title,
    useRealTheory: true,
    seoTitle: `${entry.title} – teoria i zadania | Matematron`,
    seoDescription: `Zobacz, jak ${entry.focus}. Przejdź przez teorię i przykłady, rozwiąż ćwiczenia online i sprawdź odpowiedź w quizie Matematronu.`,
    seoNote: `Naucz się ${entry.focus}. Zobacz rozwiązania krok po kroku, a następnie przećwicz zadania i sprawdź wynik.`,
    relatedSlugs,
  };
});
